/**
 * Limites PLD (Preço de Liquidação das Diferenças) — ANEEL fixa min/max
 * por ano regulatório. Pra 2026:
 *   PLDmin = R$ 57,31/MWh
 *   PLDmax = R$ 785,27/MWh
 *
 * Fonte: gov.br/aneel/.../2025/aneel-define-tarifas...-pld-para-2026.
 *
 * Uso (Task #65): sanidade na curva forward Convencional. Preço efetivo
 * (forward_se + agio_se + swap_<sub>) fora do range eh sintoma de erro
 * de cadastro Mesa OU situacao extrema que merece atencao. Helper retorna
 * true → UI marca celula com bg ambar + tooltip explicativo.
 *
 * Energia Incentivada (I0/I5/I100) e CQ NAO sao validadas aqui — ranges
 * proprios; Mesa precisa definir limites antes de adicionar mapping.
 *
 * Quando ANEEL divulgar 2027, adicionar `PLD_LIMITS_2027` aqui (#62
 * cobre o calendario).
 */

export interface PldRange {
  min: number;
  max: number;
}

/** PLDmin/max ANEEL 2026 — R$/MWh. */
export const PLD_LIMITS_2026: PldRange = { min: 57.31, max: 785.27 };

/** Mapping ano -> range. Quando 2027 sair, adicionar aqui. */
const PLD_BY_YEAR: Record<number, PldRange> = {
  2026: PLD_LIMITS_2026,
};

/** Devolve range PLD pro ano dado. Null se ano nao tem constantes
 * cadastradas — UI nao valida (skip silencioso, evita falso warning
 * em janelas 2027+ ate ANEEL publicar). */
export function pldRangeForYear(ano: number): PldRange | null {
  return PLD_BY_YEAR[ano] ?? null;
}

/** True se `preco` esta FORA de [min, max] do ano regulatorio.
 * Boundaries (57.31 e 785.27) sao consideradas DENTRO do range — ANEEL
 * fixa os limites como inclusive. NaN/null/undefined retornam false
 * (sem dados nao gera warning). Ano sem constantes retorna false.
 */
export function isOutOfPldRange(
  preco: number | null | undefined,
  ano: number,
): boolean {
  if (preco === null || preco === undefined || !Number.isFinite(preco)) {
    return false;
  }
  const range = pldRangeForYear(ano);
  if (range === null) return false;
  return preco < range.min || preco > range.max;
}
